import React, { useContext } from "react";
import { T } from "../../../../hooks/useTranslate";

import { DateTime } from "luxon";

import { Stack, Typography, Skeleton } from "@mui/material";

import { DistributorContext } from "../../../../hooks/DistributorContext";
import { SuccessTrackerSelectDropdown } from "./SuccessTrackerSelectDropdown";
import { RankQualSection } from "./RankQualSection";
import { CenturionSection } from "./CenturionSection";
import { RankQualAlertIcon } from "../../../DashboardScreen/RankQualifications/RankQualAlertIcon";

const SuccessTracker = () => {
  const { centurionHistory, historyApiInProgress, hasError, activeLegs, requiredLegs, isCurrentMonthSelected } = useContext(DistributorContext);
  const dateUpdated = centurionHistory.centurionHistory?.items[0].value[0].metrics[0].dateCalculated;
  const currentCentCount = parseInt(centurionHistory.centurionHistory?.items[0].value[0].metrics[0].value);

  const dt = DateTime.fromISO(dateUpdated);
  const dateString = `${dt.toLocaleString({ month: 'long', day: 'numeric' })}, ${dt.toLocaleString(DateTime.TIME_SIMPLE)}`

  const date = DateTime.now();
  const currentDayNumber = date.day;
  const isDatePast7th = currentDayNumber > 7;

  if (hasError) return (
    <Stack p={3} gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h2"><T>success_tracker</T></Typography>
        <SuccessTrackerSelectDropdown disabled={historyApiInProgress} />
      </Stack>
      <Stack alignItems="center" mb={1} mt={5}>
        <Typography variant="h3"><T>there_was_an_error</T>.</Typography>
      </Stack>
    </Stack>
  )

  return (
    <Stack p={3} gap={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Stack direction="row" gap={.75}>
          <Typography variant="h2"><T>success_tracker</T></Typography>
          {
            isCurrentMonthSelected ? (
              Number.isInteger(activeLegs) && activeLegs < requiredLegs && isDatePast7th && !historyApiInProgress && (
                <RankQualAlertIcon translationKey="not_active_legs_tooltip_text" />
              )
            ) : (
              Number.isInteger(activeLegs) && activeLegs < requiredLegs && !historyApiInProgress && (
                <RankQualAlertIcon translationKey="not_active_legs_tooltip_text" />
              )
            )
          }
        </Stack>

        <SuccessTrackerSelectDropdown disabled={historyApiInProgress} />
      </Stack>
      {
        historyApiInProgress ?
          <Stack justifyContent={"center"} alignItems={"center"} gap={2}>
            <Skeleton variant="rounded" width={350} height={300} />
            <Skeleton variant="rounded" width={350} height={100} />
          </Stack>
          :
          <Stack gap={2}>
            <RankQualSection />
            <CenturionSection currentCentCount={isNaN(currentCentCount) ? 0 : currentCentCount} />
            {
              dateUpdated &&
              <Typography variant="h6" textAlign="center" mt={2}><T>updated</T>: {dateString}</Typography>
            }
          </Stack>
      }
    </Stack>
  )
}

export { SuccessTracker }